<h1 class="display">Enter your 2FA</h1>
<section class="ctx-card">
  <section class="ctx-card__content">
    <form
      [formGroup]="formGroup"
      (ngSubmit)="verify()"
      class="flex flex-col gap-4"
    >
      <section class="flex flex-col gap-4">
        @if (showApiMessage) {
        <ctx-alert [alertLevel]="apiMessage.alertLevel">{{
          apiMessage.text
        }}</ctx-alert>
        } @if (!recoverMode) {
        <mat-form-field>
          <mat-label>Two-Factor Code</mat-label>
          <input
            type="text"
            matInput
            #input
            formControlName="twoFactorCode"
            [required]="!recoverMode"
          />
          <mat-error>{{
            getControlError(formGroup, 'twoFactorCode')
          }}</mat-error>
        </mat-form-field>
        } @if (recoverMode) {
        <mat-form-field>
          <mat-label>Two-Factor Recovery Code</mat-label>
          <input
            type="text"
            matInput
            #input
            formControlName="twoFactorRecoveryCode"
            [required]="recoverMode"
          />
          <mat-error>{{
            getControlError(formGroup, 'twoFactorRecoveryCode')
          }}</mat-error>
        </mat-form-field>
        }
        <button ctx-button--primary [loading]="formStates.submit" type="submit">
          Verify
        </button>
        @if (!recoverMode) {
        <div class="flex flex-col gap-3">
          <span class="text-center">
            Can't access your authenticator app?
          </span>
          <button ctx-button--secondary (click)="recoverMode = true">
            Enter a recovery code
          </button>
        </div>
        }@else {
        <div class="flex flex-col gap-3">
          <span class="text-center"> Can access your authenticator app? </span>
          <button ctx-button--secondary (click)="recoverMode = false">
            Enter a 2FA code
          </button>
        </div>
        }
      </section>
    </form>
  </section>
</section>
